module.exports = __webpack_public_path__ + "img/b1.a63bb1e2.jpg";